/* eslint-disable */

import { ConfirmDialog as View } from './ConfirmDialog';
import { enhancer } from './ConfirmDialog.enhancer';

export const ConfirmDialog = enhancer(View);
